import { useQuery } from "@apollo/client";
import {
  GetWysiwygArtifactQueryQuery,
  GetWysiwygArtifactQueryQueryVariables,
  GoalArtifactNode,
} from "types/graphql-schema";

import GoalKeyResultItemReadOnly from "@apps/artifact-sidebar/components/goal-key-result-item";
import { assertEdgesNonNull } from "@helpers/helpers";

import getWysiwygArtifactQuery from "../graphql/get-wysiwyg-artifact-query";

const ArtifactComponentGoalKeyResults = ({
  artifactId,
}: {
  artifactId: number;
}) => {
  const { data } = useQuery<
    GetWysiwygArtifactQueryQuery,
    GetWysiwygArtifactQueryQueryVariables
  >(getWysiwygArtifactQuery, {
    fetchPolicy: "cache-only", // rely only on cached content to render this view
    variables: { artifactId: Number(artifactId) },
  });

  const goal = data?.artifact as GoalArtifactNode;
  const keyResults = goal?.keyResults
    ? assertEdgesNonNull(goal.keyResults)
    : [];

  if (keyResults.length > 0) {
    return (
      // 8px gap between each row; 8px top margin separates the group from
      // the header. Last-checkin "updates" are intentionally hidden in the
      // embed — that information lives in the artifact sidebar.
      <div className="mt-2 flex flex-col gap-2">
        {keyResults.map((keyResult) => (
          <div key={keyResult.id} className="flex gap-2 not-prose">
            {/* 16x16 container with a centered gray-400 dot — matches the
                rest of the artifact icons (16x16 sizing, mt-0.5 baseline).
                8px gap (gap-2) between this and the key-result content. */}
            <div className="shrink-0 w-4 h-4 mt-0.5 flex items-center justify-center">
              <div className="w-1.5 h-1.5 rounded-full bg-gray-400" />
            </div>
            <div className="flex-1 min-w-0">
              <GoalKeyResultItemReadOnly
                goalArtifact={goal}
                keyResult={keyResult}
                isReadOnly
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default ArtifactComponentGoalKeyResults;
